import { createContext } from "react";

export const ClassIdsContext = createContext(null);
